import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styless.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { PanierProvider } from "./contexts/PanierContext";
import { ProfilProvider } from "./contexts/ProfilContext";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Création du client React Query
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ProfilProvider>
        <PanierProvider>
          <App />
        </PanierProvider>
      </ProfilProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// ============================================================
// PWA
// ------------------------------------------------------------
// Enregistre le service worker en production pour rendre
// l'application installable.
// ============================================================

serviceWorkerRegistration.register();
